
import { BellDot } from "lucide-react";
import { cn } from "@/lib/utils";

type NotificationIconProps = {
  count?: number;
  className?: string;
  onClick?: () => void;
};

export function NotificationIcon({ count, className, onClick }: NotificationIconProps) {
  return (
    <div 
      className={cn("relative cursor-pointer", className)} 
      onClick={onClick}
    >
      <BellDot className="h-5 w-5" />
      {count && count > 0 && (
        <div className="absolute -top-1 -right-1 bg-destructive text-destructive-foreground text-xs rounded-full h-4 min-w-4 flex items-center justify-center px-1">
          {count > 99 ? '99+' : count}
        </div>
      )}
    </div>
  );
}
